<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8  ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>पे जी की विशेषताएं </h2>
                </div>
                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>
                </div>
                <div class="col-md-12" (mouseover)="showpayment(true,'1')" (mouseout)="showpayment(false,'1')" id="1">
                    <!-- <div style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe class="i-frame" src="https://www.youtube.com/embed/5kY7ApMM9Uo"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div> -->
                    <label for="" class="mt-4">पे जी ऑनलाइन लेनदेन को सुविधाजनक बनाने और व्यवसायों को सुरक्षित और कुशलता से भुगतान स्वीकार करने में सक्षम बनाने के लिए कई प्रकार की सुविधाएँ और सेवाएँ प्रदान करता है। पे जी की कुछ सामान्य विशेषताओं में शामिल हैं:  </label>


                   <ol class="mt-4">
                    <li  class="mt-4"><b> एकाधिक भुगतान विकल्प:  &nbsp;</b>भुगतान गेटवे क्रेडिट और डेबिट कार्ड, नेट बैंकिंग, यूपीआई, मोबाइल वॉलेट और अन्य डिजिटल भुगतान विकल्पों सहित विभिन्न भुगतान विधियों का समर्थन करते हैं, जिससे ग्राहकों को अपने पसंदीदा मोड का उपयोग करके भुगतान करने की अनुमति मिलती है। </li>
                    <li  class="mt-4"><b> सुरक्षित लेनदेन:  &nbsp;</b>भुगतान गेटवे एन्क्रिप्शन और अन्य सुरक्षा उपायों को नियोजित करते हैं ताकि यह सुनिश्चित किया जा सके कि संवेदनशील ग्राहक जानकारी, जैसे कार्ड विवरण, भुगतान प्रक्रिया के दौरान सुरक्षित रहे। </li>
                    <li  class="mt-4"><b> भुगतान सहायता: &nbsp;</b>पे जी पूरे भारत में भुगतान सहायता प्रदान करता है, जिससे व्यवसायों को विभिन्न राज्यों/केंद्र शासित प्रदेशों में स्थित ग्राहकों से भुगतान स्वीकार करने की अनुमति मिलती है।  </li>
                    <li  class="mt-4"><b>रीयल-टाइम रिपोर्टिंग और एनालिटिक्स: &nbsp;</b> व्यवसाय अपनी भुगतान गतिविधि की निगरानी कर सकते हैं और पेजी द्वारा प्रदान किए गए डैशबोर्ड की बदौलत सफलता को ट्रैक कर सकते हैं जो रीयल-टाइम लेनदेन डेटा, एनालिटिक्स और अंतर्दृष्टि प्रदान करते हैं। </li>
                    <li  class="mt-4"><b>भुगतान बटन अनुकूलन:  &nbsp;</b> पे जी भुगतान बटन के लिए अनुकूलन विकल्प प्रदान करता है, जिससे व्यवसायों को सहज उपयोगकर्ता अनुभव के लिए अपनी वेबसाइटों के ब्रांडिंग और डिज़ाइन तत्वों से मेल खाने में सक्षम बनाया जाता है। </li>
                    <li  class="mt-4"><b> धोखाधड़ी की रोकथाम और जोखिम प्रबंधन:&nbsp;</b>  धोखाधड़ी वाले लेनदेन की पहचान करने और उन्हें कम करने के लिए, पे जी धोखाधड़ी सुरक्षा प्रौद्योगिकियों और जोखिम प्रबंधन प्रणालियों का उपयोग करता है, जो चार्जबैक और नुकसान की संभावना को कम करता है। </li>
                    <li  class="mt-4"><b> 24/7 ग्राहक सहायता: &nbsp;</b> पे जी किसी भी भुगतान-संबंधी समस्या या प्रश्न के साथ व्यवसायों और ग्राहकों की सहायता के लिए चौबीसों घंटे ग्राहक सहायता प्रदान करता है। 

                    </li>
                    <li  class="mt-4"><b>पीसीआई अनुपालन:  &nbsp;</b>पेजी भुगतान कार्ड उद्योग डेटा सुरक्षा मानक (पीसीआई डीएसएस) अनुपालन का पालन करता है, जो कार्डधारक की जानकारी के लिए उच्चतम स्तर की डेटा सुरक्षा सुनिश्चित करता है। </li>
                    <li  class="mt-4"><b>त्वरित निपटान:  &nbsp;</b> जो व्यवसाय पे जी की त्वरित निपटान सेवा का उपयोग करते हैं, वे सफल लेनदेन के तुरंत बाद अपने बैंक खातों में पैसा प्राप्त कर सकते हैं। </li>
                    <li  class="mt-4"><b>भुगतान रूटिंग:  &nbsp;</b>पे जी भुगतान रूटिंग का समर्थन करता है, जो भुगतान सफलता दर को अनुकूलित करने के लिए स्वचालित रूप से विभिन्न प्रोसेसर या अधिग्रहणकर्ताओं के माध्यम से लेनदेन को रूट करता है। </li>
                    <li  class="mt-4"><b> वर्चुअल पीओएस (प्वाइंट ऑफ सेल): &nbsp;</b>  पे जी द्वारा प्रदान किए गए वर्चुअल पीओएस टर्मिनल व्यवसायों को ऑनलाइन, फोन पर या अन्य दूरस्थ तरीकों से भुगतान स्वीकार करने में सक्षम बनाते हैं। </li>
                    
                   </ol>
                </div>
               
            </div>
        </div>
    </div>
    <div class="col-md-4  hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        विषयसूची :
                    </h5>
                </div>
               
                <div class="col-md-12">
                    <a href="#1">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'color':colors=='1'}"
                                    (click)="color('1')">
                                    पे-जी की विशेषताएं </span>

                            </div>
                        </div>
                    </a>
                </div>
           

              


            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8" style="width:70%">
                <a [routerLink]="['/onboarding']"> <button class="btn btn-color" > <img
                            src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;ऑनबोर्डिंग 
                    </button></a>

            </div>
            <div class="col-md-4        " style="width:30%">
                <a [routerLink]="['/coupons']"> <button class="btn btn-color"
                        (click)="menues('Web Integration')">कूपन
                        &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>

            </div>
        </div>
    </div>
</div>